import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiDialogsProgressComponent } from '@fi-shared/fi-dialogs-generic/progress/progress.component';
import { FiDialogsGenericService } from '@fi-shared/fi-dialogs-generic/fi-dialogs-generic.service';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiDialogConfirmDeleteComponent } from '@fi-shared/fi-dialogs-generic/confirm-delete/dialog-confirm-delete.component';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { FiWarningConfirmDialogComponent } from '@fi-shared/fi-dialogs-generic/warning-confirm/fi-warning-confirm-dialog.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    imports: [CommonModule, FormsModule, MatProgressBarModule, FiAppTextSharedModule, MatInputModule, MatIconModule],
    declarations: [FiDialogsProgressComponent, FiDialogConfirmDeleteComponent, FiWarningConfirmDialogComponent],
    providers: [FiDialogsGenericService],
})
export class FiDialogsGenericModule {}
